var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"icoButton",class:_vm.classRefreshing,attrs:{"data-icoTarget":"sync"},on:{"click":_vm.clickIco}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }